import { Actions, Subjects } from '@/client/users';
import { useAppSelector } from '@/hooks/store';
import {
  selectCurrentUserAbility,
  selectCurrentUserCustomRoleCeiling,
} from '@/store/features/users';

// Custom hook to determine permissions
export const usePermission = () => {
  const ability = useAppSelector(selectCurrentUserAbility);
  const ceiling = useAppSelector(selectCurrentUserCustomRoleCeiling);

  const can = (action: Actions, subject: Subjects) =>
    ability ? ability.can(action, subject) : false;

  const cannot = (action: Actions, subject: Subjects) =>
    ability ? ability.cannot(action, subject) : false;

  const isRestrictedByRole = (action: Actions, subject: Subjects) =>
    !!ceiling && !can(action, subject) && ceiling.can(action, subject);

  const canReach = (action: Actions, subject: Subjects) =>
    can(action, subject) || isRestrictedByRole(action, subject);

  return { can, cannot, isRestrictedByRole, canReach };
};
